import { useRef, useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { useHotkeys } from "react-hotkeys-hook";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { returnBillCreateAction, returnBillUpdateAction } from "../../redux/actions/invoices-action";
import successToast from "../helper-components/success-toast";
import errorToast from "../helper-components/error-toast";
import moment from "moment";
import { handlea4Print } from "../helper-components/helper-function";
import BillingHeaderSection from "../invoice-section/billing-header-section";
import ReturnBillItemsSection from "./return-items-section";
import ReturnBillFooterSection from "./return-bill-footer-section";
import BillingPaymentPanel from "../invoice-section/billing-payment-panel";

const CreateEditViewReturnBilling = ({
  disabled = false,
  storeId = {},
  orderDetail = {},
  page = "",
}) => {
  console.log(orderDetail, "fgdfgfdgfdgfdgfdgfd");
  const [isPrint,setIsPrint]=useState(false);
  const searchRef = useRef(null);
  const [paymentPanel, setPaymentPanel] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  const initialFormValues = {
    phone: orderDetail?.vendorDetails?.cmr_phone_number
      ? {
          label: orderDetail?.vendorDetails?.cmr_phone_number,
          value: orderDetail?.vendorDetails?.cmr_id,
        }
      : "",
    cmr_first_name: orderDetail?.vendorDetails?.cmr_first_name,
    cmr_id: orderDetail?.vendorDetails?.cmr_id,
    cmr_last_name: orderDetail?.vendorDetails?.cmr_last_name,
    icn_sub_total: orderDetail?.orderData?.icn_sub_total,
    icn_total_amount: orderDetail?.orderData?.icn_total_amount,
    icn_total_gst: orderDetail?.orderData?.icn_total_gst,
    icn_total_discount: orderDetail?.orderData?.icn_total_discount,
    icn_round_off_value: orderDetail?.orderData?.icn_round_off_value,
    icn_is_invoice_dis_percentage:
      orderDetail?.orderData?.icn_is_invoice_dis_percentage ?? true,
    icn_invoice_discount: orderDetail?.orderData?.icn_invoice_discount ?? 0,
    icn_invoice_discount_percentage:
      orderDetail?.orderData?.icn_invoice_discount_percentage ?? 0,
    header_inv_dis_per: orderDetail?.orderData?.icn_is_invoice_dis_percentage
      ? orderDetail?.orderData?.icn_invoice_discount_percentage
      : orderDetail?.orderData?.icn_invoice_discount,
    icn_custom_invoice_date: orderDetail?.orderData?.icn_custom_invoice_date
      ? moment(orderDetail?.orderData?.icn_custom_invoice_date).format(
          "YYYY-MM-DD"
        )
      : null,
    icn_custom_invoice_number:
      orderDetail?.orderData?.icn_custom_invoice_number || "",
    icn_ship_from_address:
      page === "view"
        ? orderDetail?.orderData?.icn_ship_from_address
        : orderDetail?.itemData?.[0]?.sot_ship_to_address || null,

    // icn_ship_from_address:
    //   orderDetail?.itemData?.[0]?.sot_ship_to_address || null, //new
    icn_reason: orderDetail?.orderData?.icn_reason, //new
    otherStores: {},

    data: [
      ...orderDetail?.itemData?.map((item, index) => ({
        sl_no: index + 1,
        linked_invoice_number:
          item?.linked_invoice_number ?? item?.sot_invoice_number,
        item_code: item?.item_code,
        item_generic_name: item?.item_generic_name,
        item_name: item?.item_name,
        item_open_quantity: item?.item_open_quantity,
        quantity:
          page === "view" ? item?.item_quantity : item?.item_open_quantity,
        item_free_quantity:
          item?.item_free_quantity === null ? 0 : item?.item_free_quantity ?? 0,
        item_uom: item?.item_uom,
        item_batch_number: item?.item_batch_number,
        item_exp_date: item?.item_exp_date
          ? moment(item?.item_exp_date).format("YYYY-MM-DD")
          : "--",
        item_rack_location: item?.item_rack_location,
        item_manufacturer_name: item?.item_manufacturer_name,
        item_schedule: item?.item_schedule,
        item_hsn: item?.item_hsn,
        item_unit_price: item?.item_unit_price,
        item_price_wiithout_tax: item?.item_price_wiithout_tax,
        item_discount_amount: item?.item_discount_amount,
        item_discount_percentage: item?.item_discount_percentage,
        item_tax_amount: item?.item_tax_amount,
        item_gst: item?.item_gst,
        item_final_price: item?.item_final_price,
        item_total_amount: item?.item_total_amount,
        item_id: item?.item_id,
        instock: true,
        item_cgst: item?.item_cgst,
        item_sgst: item?.item_sgst,
        itemBatchList: item?.itemBatchList,
        sot_id: item?.sot_id,
        item_max_free_quantity:
          parseInt(item?.item_free_quantity ?? 0, 10) || 0,
        item_manufacturer_id: item?.item_manufacturer_id ?? "",
      })),
    ],
    icn_remarks:
      orderDetail?.vendorDetails?.icn_remarks ?? "Thank you for choosing us 🙏🏼",
    paymentData: (orderDetail?.paymentData || []).map((pay) => ({
      payment_mode_name: pay?.payment_mode_name,
      payment_amount: pay?.payment_amount ?? 0,
    })),
  };
  const [initialValue] = useState(initialFormValues);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const validationSchema = Yup.object().shape({
    phone: Yup.object()
    .required("Phone number is required")
    .test("is-ten-digits", "Please enter valid phone number", (value) => {
      const label = value?.label?.toString() ?? "";
      const candidate = label.includes(",")
        ? label.split(",")[1].trim()
        : label.trim();
      return /^\d{10}$/.test(candidate);
    }),

    icn_custom_invoice_date: Yup.string().required(
      "Custom invoice date is required"
    ),
    icn_reason: Yup.string().nullable().notRequired(),
  });

  const handleBilling = (values, resetForm) => {
    setTimeout(() => {
      if (
        values?.data.some(
          (item) => parseInt(item.quantity) === 0 || item.quantity === ""
        )
      ) {
        errorToast("Quantity cannot be zero");
      } else {
        setSubmitLoading(true);
        const isEdit = page === "view";
        const payload = {
          orderData: {
            icn_ship_from_address: values?.icn_ship_from_address, //new
            is_draft_order:
              values.submittedButton === "draft" ? true : false,
            store_id: storeId,
            cmr_phone_number: parseInt(values?.phone?.label?.includes(",") ? values.phone.label.split(",")[1].trim() : values?.phone?.label),
            icn_total_gst: values?.icn_total_gst,
            icn_total_discount: values?.icn_total_discount,
            icn_payment_status:
              values.submittedButton === "draft" ? "pending" : "paid",
            icn_transaction_id: "",
            icn_payment_method: values?.payment_method,
            icn_billing_address: "",
            icn_sub_total: values?.icn_sub_total,
            icn_total_amount: values?.icn_total_amount,
            doctor_name: values?.doctor?.value,
            icn_remarks: values?.icn_remarks,
            cmr_id: values?.cmr_id,
            icn_is_invoice_dis_percentage:
              values?.icn_is_invoice_dis_percentage,
            icn_invoice_discount: values?.icn_invoice_discount,
            icn_invoice_discount_percentage:
              values?.icn_invoice_discount_percentage,
            icn_custom_invoice_date: values?.icn_custom_invoice_date || "",
            icn_custom_invoice_number:
              values?.icn_custom_invoice_number || "",
            icn_reason: values?.icn_reason, //new
            ...(isEdit && orderDetail?.orderData?.icn_id
              ? { icn_id: orderDetail.orderData.icn_id }
              : {}),
          },
          paymentData: values?.paymentData?.map((pay) => ({
            payment_mode_name: pay?.payment_mode_name,
            payment_amount: pay?.payment_amount,
          })),
          itemData: values?.data?.map((item, index) => ({
            sot_id: item?.sot_id,
            item_code: item?.item_code,
            item_generic_name: item?.item_generic_name,
            item_name: item?.item_name,
            item_quantity: parseInt(item?.quantity),
            item_open_quantity: parseInt(item?.item_open_quantity),
            item_free_quantity:
              parseInt(item?.item_free_quantity ?? 0, 10) || 0,
            item_uom: item?.item_uom,
            item_batch_number: item?.item_batch_number,
            item_exp_date: moment(item?.item_exp_date).format("YYYY-MM-DD"),
            item_rack_location: item?.item_rack_location,
            item_schedule: item?.item_schedule,
            item_hsn: item?.item_hsn,
            item_unit_price: parseFloat(item?.item_unit_price),
            item_price_wiithout_tax: parseFloat(
              item?.item_price_wiithout_tax
            ),
            item_discount_amount: parseFloat(item?.item_discount_amount),
            item_discount_percentage: parseFloat(
              item?.item_discount_percentage
            ),
            item_tax_amount: item?.item_tax_amount,
            item_total_amount: item?.item_total_amount,
            item_id: item?.item_id,
            item_gst: parseFloat(item?.item_gst),
            item_sgst: parseFloat(item?.item_sgst||0),
            item_cgst: parseFloat(item?.item_cgst||0),
            item_manufacturer_id: item?.item_manufacturer_id ?? "",
            item_manufacturer_name: item?.item_manufacturer_name ?? "",
          })),
        };

        const action = isEdit ? returnBillUpdateAction : returnBillCreateAction;
        dispatch(action(payload, onSuccessOrder, onErrorOrder));
      }
    }, 400); // Timeout set to 100ms
  };

  const onSuccessOrder = (data) => {
    navigate("/return-bills");
    if(isPrint){
      handlea4Print(
        data?.data?.orderData?.[0]?.icn_id,
        "invoice_credit_note",
        dispatch
      );
    }
    successToast(data?.message);
    setTimeout(() => {}, 50);
  };
  const onErrorOrder = () => {
    setSubmitLoading(false);
    errorToast("Something went wrong, please try again later.");
  };
  useHotkeys("escape", () => {});

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={initialValue}
        validationSchema={validationSchema}
        onSubmit={async (values, { resetForm }) => {
          if (values.submittedButton === "proceed") {
            setPaymentPanel(true); // Trigger payment panel
          } else {
            //setIsPrint(values.submittedButton==="print");
            handleBilling(values, resetForm); // Proceed with billing
          }
        }}
      >
        {({ handleSubmit, errors }) => {
          console.log(errors, "Dfdsfsdfsdfsdfsdfsdfsd");
          return (
            <Form className="h-full w-full">
              <div
                style={{
                  height: `calc(100% - 8rem)`,
                }}
                className="mx-5 flex flex-col h-full "
              >
                <BillingHeaderSection
                  type="return"
                  prefixName="icn"
                  name="icn"
                  page={page}
                  disabled={disabled}
                  searchRef={searchRef}
                />
                <ReturnBillItemsSection />
              </div>

              <ReturnBillFooterSection
                prefixName="icn"
                returnCreateInputs={[
                  {
                    type: "footer",
                    label: "Remarks",
                    value: "remarks",
                    enabled: true,
                  },
                  {
                    type: "footer",
                    label: "Invoice Discount",
                    value: "header_inv_dis_per",
                    enabled: true,
                    alignment: "left",
                  },
                ]}
                page={page}
                disabled={disabled}
              />

              <BillingPaymentPanel
                prefixName="icn"
                disabled={disabled}
                submitLoading={submitLoading}
                handleSubmit={handleSubmit}
                payModesList={[
                  { label: "Credit", value: "Credit" },
                  { label: "Cash", value: "Cash" },
                  { label: "Upi", value: "Upi" },
                ]}
                open={paymentPanel}
                setOpen={setPaymentPanel}
                setIsPrint={setIsPrint}
              />
            </Form>
          );
        }}
      </Formik>
    </>
  );
};
export default CreateEditViewReturnBilling;
